<template>
  <div class="card card-custom card-stretch gutter-b">
    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">
          Nova Configurações
        </span>
      </h3>
    </div>
    <Form url="/configuracoes/create" :configuracao="configuracao" />
  </div>
</template>

<script>
import Form from "./Form.vue";
import ConfiguracaoData from "./ConfiguracaoData";
import { mapGetters } from "vuex";

export default {
  name: "app-configuracoes-create",
  data() {
    return {
      configuracao: new ConfiguracaoData({}),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
</script>
